module.exports = __webpack_public_path__ + "img/zip.1a0bd082.svg";